/**
 * the Entity Data Model module
 */
import schemaPlugin from './schema-plugin';
import typesPlugin from './types-plugin';
import type {
  EdmOptions,
  EdmSchemaRegistry,
  EntityDataModel,
  ResourceIdentifierRegistry,
  TypeRegistry,
} from '../types';

export interface EDM extends EntityDataModel {
  readonly types: TypeRegistry;
  readonly schema?: EdmSchemaRegistry;
  readonly resourceIdentifiers?: ResourceIdentifierRegistry;
}

export class EDM {
  constructor(options?: EdmOptions) {
    typesPlugin(this);
    if (options) {
      schemaPlugin(this, options);
    }
  }
}
